import { Box } from '@mui/system'
import React from 'react'
import { useTreeContext } from '../../../TreeProvider'
import CustomCheckbox from 'packages/ui/Checkbox'

interface NodeCheckboxProps {
  onChange?: (e: React.MouseEvent, checked: boolean) => void
  node: any
  sx?: any
  visible?: boolean
  indeterminate?: boolean
  disabled?: boolean
  checked?: boolean
}

const NodeCheckbox: React.FC<NodeCheckboxProps> = ({
  onChange,
  node,
  sx,
  visible = true,
  indeterminate,
  disabled,
  checked
}) => {
  const { waiting } = useTreeContext()

  const handleChange = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (!waiting && !disabled) {
      onChange?.(e, !checked)
    }
  }

  return (
    <Box
      sx={{
        ...sx,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: waiting ? 'wait' : 'inherit'
      }}
    >
      {visible && (
        <CustomCheckbox
          disabled={disabled || waiting}
          checked={checked || node.isSelected}
          indeterminate={indeterminate}
          onChange={handleChange}
        />
      )}
    </Box>
  )
}

export default NodeCheckbox
